import React, { useEffect, useState } from "react";
import { MapPin, Phone, Mail, Map } from "lucide-react";

const StoreBranches = ({ storeId }) => {
  const [branches, setBranches] = useState([]);
  const [openCity, setOpenCity] = useState(null);

  // 🔹 Discover More links (future-proof for API)
  const discoverLinks = [
    { text: "Dubai", link: "#" },
    { text: "Electronic gadgets reviews", link: "#" },
    { text: "Kitchen appliances", link: "#" },
    { text: "Discount offer alerts", link: "#" },
    { text: "Branded apparel online", link: "#" },
    { text: "Discount coupon website", link: "#" },
    { text: "Online catalog viewer", link: "#" },
    { text: "Discounted electronics deals", link: "#" },
    { text: "Cleaning supplies subscription", link: "#" },
    { text: "Retail catalog browsing", link: "#" },
  ];

  useEffect(() => {
    const fetchBranches = async () => {
      try {
        const response = await fetch(
          `https://api.gulf.deals/store-offer/store/${storeId}/branches`
        );
        const data = await response.json();
        setBranches(data);
      } catch (err) {
        console.error("Error:", err);
      }
    };

    fetchBranches();
  }, [storeId]);

  const branchesByCity = branches.reduce((acc, br) => {
    if (!acc[br.city]) acc[br.city] = [];
    acc[br.city].push(br);
    return acc;
  }, {});

  return (
    <div className="w-full max-w-6xl mx-auto p-4">

      {/* OUTER WRAPPER CARD */}
      <div className="border rounded shadow bg-white">

        {/* HEADER BAR */}
        <div className="border-b bg-orange-100 p-4 md:w-1/4 m-2">
          <h2 className="text-xl font-bold text-gray-800">UAE BRANCHES</h2>
        </div>

        {/* CONTENT AREA */}
        <div className="p-2">
          {Object.keys(branchesByCity).map((city) => (
            <div key={city} className="border rounded mb-3 bg-gray-50">

              {/* ACCORDION HEADER */}
              <div
                className="flex justify-between items-center p-4 bg-gray-200 cursor-pointer"
                onClick={() => setOpenCity(openCity === city ? null : city)}
              >
                <span className="text-lg font-semibold">{city}</span>
                <span className="text-2xl font-bold">
                  {openCity === city ? "−" : "+"}
                </span>
              </div>

              {/* CONTENT */}
              {openCity === city && (
                <div className="p-0">
                  <table className="w-full border-collapse">
                    <thead>
                      <tr className="bg-gray-200 border-b">
                        <th className="text-left p-3 font-semibold w-1/2">
                          Address
                        </th>
                        <th className="text-left p-3 font-semibold w-1/2">
                          Opening hours
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      {branchesByCity[city].map((branch) => (
                        <tr key={branch.id} className="border-b align-top">

                          {/* LEFT */}
                          <td className="p-4 border-r border-gray-300">
                            <div className="font-bold text-md mb-2">
                              {branch.branchName}
                            </div>

                            <div className="space-y-1 text-sm text-gray-700">
                              <div className="flex gap-2">
                                <MapPin className="w-4 h-4 mt-1" />
                                <span>{branch.address}</span>
                              </div>

                              <div className="flex gap-2">
                                <Phone className="w-4 h-4 mt-1" />
                                <span>{branch.phoneNumber || "N/A"}</span>
                              </div>

                              {branch.altPhoneNumber && (
                                <div className="flex gap-2">
                                  <Phone className="w-4 h-4 mt-1" />
                                  <span>{branch.altPhoneNumber}</span>
                                </div>
                              )}

                              {branch.email && (
                                <div className="flex gap-2">
                                  <Mail className="w-4 h-4 mt-1" />
                                  <span>{branch.email}</span>
                                </div>
                              )}

                              <div className="flex gap-2 text-blue-600 cursor-pointer">
                                <Map className="w-4 h-4 mt-1" />
                                <a
                                  href={`https://www.google.com/maps?q=${branch.latitude},${branch.longitude}`}
                                  target="_blank"
                                >
                                  MAP & DIRECTIONS
                                </a>
                              </div>

                              <div className="flex gap-2 text-blue-600 cursor-pointer">
                                <Map className="w-4 h-4 mt-1" />
                                <a href="#">View Branch Details</a>
                              </div>
                            </div>
                          </td>

                          {/* RIGHT */}
                          <td className="p-4 text-sm text-gray-700 align-top">
                            {branch.openingHours || "Not Available"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* NOTICE BOX (GREEN) */}
        <div className="bg-green-100 p-4 mt-4 text-gray-700 border-t m-2">
          <p>
            Above listed store information and timings are to the best of our
            knowledge and may change without prior notice.
          </p>
          <p>
            Timings may change during Ramadan and public holidays and hence
            kindly check with the stores to avoid last minute disappointments.
          </p>
        </div>

        {/* DISCOVER MORE SECTION */}
        <div className="p-5">
          <h3 className="text-lg font-semibold mb-3">Discover more</h3>

          <div className="flex flex-wrap gap-3">
            {discoverLinks.map((item, i) => (
              <a
                key={i}
                // href={item.link}
                className="px-3 py-1.5 border rounded-full text-blue-700 text-sm hover:bg-blue-50 flex items-center gap-2 cursor-pointer"
              >
                <span className="text-blue-600 text-lg">⟳</span>
                {item.text}
              </a>
            ))}
          </div>
        </div>

      </div>
    </div>
  );
};

export default StoreBranches;
